import excelIcon from '@assets/images/excel-icon.svg'
import pdfIcon from '@assets/images/pdf-icon.svg'
import wordIcon from '@assets/images/word-icon.svg'
import imageIcon from '@assets/images/image-icon.svg'
import defaultFileIcon from '@assets/images/file-default-icon.svg'
import { getFileTypeFromName } from '@utils/string'
import { FilePreview } from './FileIcon.styled'

export type FileType = 'image' | 'pdf' | 'word' | 'excel' | 'csv' | 'unknown'

interface FileIconProps {
  fileName: string
  fileUrl?: string
}

const FILE_TYPE_ICONS: Record<FileType, string> = {
  pdf: pdfIcon,
  word: wordIcon,
  excel: excelIcon,
  csv: excelIcon,
  image: imageIcon,
  unknown: defaultFileIcon,
} as const

const getIconByType = (type: FileType): string => {
  return FILE_TYPE_ICONS[type] || defaultFileIcon
}

const shouldUseCrossOrigin = (fileUrl?: string): 'anonymous' | undefined => {
  return fileUrl?.includes('s3') ? undefined : 'anonymous'
}

export const FileIcon: React.FC<FileIconProps> = ({ fileName, fileUrl }: FileIconProps) => {
  const fileType = getFileTypeFromName(fileName)
  const iconSrc = getIconByType(fileType)

  const src = fileUrl && fileType === 'image' ? fileUrl : iconSrc

  return <FilePreview src={src} crossOrigin={shouldUseCrossOrigin(fileUrl)} />
}
